import { createContext, useContext } from 'react';

export type WordsHappenTabsContextValue = {
  activeValue: string;
  baseId: string;
  setActiveValue: (value: string) => void;
};

export const WordsHappenTabsContext = createContext<WordsHappenTabsContextValue | null>(null);

export function useWordsHappenTabsContext(): WordsHappenTabsContextValue {
  const context = useContext(WordsHappenTabsContext);
  if (!context) {
    throw new Error('WordsHappenTabs sub-components must be used within <WordsHappenTabs>');
  }
  return context;
}

/** The IDs that tie each tab to its panel. */
export const tabId = (baseId: string, value: string) => `${baseId}-tab-${value}`;
export const panelId = (baseId: string, value: string) => `${baseId}-panel-${value}`;
